import { FC, useContext } from 'react';
import { IButtonCommonProps } from './constants/Button.interface';
import { Link, LinkProps } from 'react-router';

import { getButtonClass, getButtonStyle } from './helpers';
import { context } from '../../../Theme/Context';
import '../ButtonGeneralStyles.css';
import './Button.css';

type Props = {
  linkProps: LinkProps;
};

const ButtonLink: FC<IButtonCommonProps & Props> = ({ testId, variant, label, linkProps }) => {
  const theme = useContext(context);

  return (
    <Link
      {...linkProps}
      data-testid={testId}
      className={getButtonClass({
        variant,
        disabled: false,
        className: `no-underline ${linkProps?.className || ''}`,
      })}
      style={{
        ...getButtonStyle({ variant, theme }),
        ...(linkProps?.style || {}),
      }}
    >
      {label}
    </Link>
  );
};

export default ButtonLink;
